import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";
import { useUpgradeModal } from "@/contexts/UpgradeModalContext";
import { SAGE } from "@shared/brand";

const VALUE_ITEMS = [
  "69-task guided checklist",
  "15 pre-filled government forms",
  "31 notification letter templates",
  "Estate financial summary",
  "AI statement scanner",
];

export function UpgradeModal() {
  const { isOpen, options, closeUpgradeModal } = useUpgradeModal();

  const subtitle = options?.toolName
    ? `${options.toolName} is part of Complete.`
    : "Your executor needs these tools to settle the estate.";

  const handleUpgrade = () => {
    console.log("[upgrade-intent:confirmed]", {
      triggerSource: options?.triggerSource,
      toolName: options?.toolName,
      timestamp: new Date().toISOString(),
    });
    closeUpgradeModal();
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) closeUpgradeModal(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-xl">Complete your plan</DialogTitle>
        </DialogHeader>

        <p className="text-sm text-muted-foreground">{subtitle}</p>

        <ul className="space-y-2 my-2">
          {VALUE_ITEMS.map((item) => (
            <li key={item} className="flex items-start gap-2 text-sm">
              <Check className="w-4 h-4 mt-0.5 shrink-0" style={{ color: SAGE[600] }} />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <p className="text-xs text-muted-foreground border-t pt-3">
          Essential $199 → Complete $499. Upgrade anytime. Pay the difference ($300).
        </p>

        <div className="flex flex-col gap-2 pt-1">
          <Button
            className="w-full text-white"
            style={{ backgroundColor: SAGE[600] }}
            onClick={handleUpgrade}
          >
            Upgrade to Complete — $300
          </Button>
          <Button variant="ghost" className="w-full text-muted-foreground" onClick={closeUpgradeModal}>
            Not now
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
